class OneTrust {
    constructor() {
    }

    init() {
        // OneTrust delete cookies
		window.addEventListener('OneTrustGroupsUpdated', (e) => {
            const activeCookieGroups = e.detail;

            // '2' is used for google cookies
            if (!activeCookieGroups.includes('2')) {
                // delete Google cookies
                const googleCookieNames = Object.keys(Cookies.get()).filter(name => name.startsWith('_ga'));
                googleCookieNames.forEach(cookieName => {
                    Cookies.remove(cookieName, {
                        path: '/',
                        domain: 'dobcinsurancequote.ca',
                    });
                    Cookies.remove(cookieName, {
                        path: '/',
                        domain: '.dobcinsurancequote.ca',
                    });
                    Cookies.remove(cookieName, {
                        path: '/',
                        domain: 'localhost',
                    });
                });
            }
        });
    }
}
